import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { ArrowRight, Calendar, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { Card } from '../components/ui/Card';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
export function ServicesPage() {
  const {
    t,
    lang
  } = useTranslation();
  const seoTitle = lang === 'en' ? 'Dental Services in Angel, London | Dentico Clinic' : lang === 'ua' ? 'Стоматологічні послуги в Angel, Лондон | Dentico Clinic' : lang === 'ro' ? 'Servicii Dentare în Angel, Londra | Dentico Clinic' : 'Стоматологические услуги в Angel, Лондон | Dentico Clinic';
  const seoDescription = lang === 'en' ? 'Explore private dental services at Dentico Clinic in Angel, including hygiene, fillings, veneers, implants, orthodontics and emergency care.' : lang === 'ua' ? 'Ознайомтеся з приватними стоматологічними послугами в Dentico Clinic в Angel, включаючи гігієну, пломби, вініри, імпланти, ортодонтію та невідкладну допомогу.' : lang === 'ro' ? 'Explorați serviciile dentare private la Dentico Clinic din Angel, inclusiv igienă, plombe, fațete, implanturi, ortodonție și îngrijire de urgență.' : 'Ознакомьтесь с частными стоматологическими услугами в Dentico Clinic в Angel, включая гигиену, пломбы, виниры, импланты, ортодонтию и неотложную помощь.';
  const services = [{
    id: 'fillings',
    title: t('services.fillings.title'),
    description: t('services.fillings.desc'),
    image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'root-canal',
    title: t('services.rootCanal.title'),
    description: t('services.rootCanal.desc'),
    image: 'https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'crowns',
    title: t('services.crowns.title'),
    description: t('services.crowns.desc'),
    image: 'https://images.unsplash.com/photo-1606265752439-1f18756aa5fc?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'hygiene',
    title: t('services.hygiene.title'),
    description: t('services.hygiene.desc'),
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'whitening',
    title: t('services.whitening.title'),
    description: t('services.whitening.desc'),
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'extraction',
    title: t('services.extraction.title'),
    description: t('services.extraction.desc'),
    image: 'https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'smile-makeover',
    title: t('services.smileMakeover.title'),
    description: t('services.smileMakeover.desc'),
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'cosmetic',
    title: t('services.cosmetic.title'),
    description: t('services.cosmetic.desc'),
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'paediatric-dentistry',
    title: t('services.paediatric.title'),
    description: t('services.paediatric.desc'),
    image: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&w=800&q=80'
  }];
  return <Layout title={seoTitle} description={seoDescription} data-id="element-3344">
      <div className="bg-forest-900 py-16 lg:py-20 text-white" data-id="element-3345">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3346">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-3347">
            {t('servicesPage.title')}
          </h1>
          <p className="text-xl text-ivory/80 max-w-2xl mx-auto" data-id="element-3348">
            {t('servicesPage.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-id="element-3349">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3350">
          {services.map(service => <Card key={service.id} hover className="overflow-hidden flex flex-col h-full border-0 shadow-lg" data-id="element-3351">
              <Link to={`/${lang}/services/${service.id}`} className="block" data-id="element-3352">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-3353">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-3354" />
                </div>
              </Link>

              <div className="p-6 flex flex-col flex-grow" data-id="element-3355">
                <Link to={`/${lang}/services/${service.id}`} data-id="element-3356">
                  <h2 className="text-xl font-bold text-charcoal mb-3 hover:text-forest-600 transition-colors" data-id="element-3357">
                    {service.title}
                  </h2>
                </Link>
                <p className="text-charcoal-light mb-6 text-sm line-clamp-2 flex-grow" data-id="element-3358">
                  {service.description}
                </p>

                <div className="flex gap-3 mt-auto" data-id="element-3359">
                  <Link to={`/${lang}/services/${service.id}`} className="flex-1" data-id="element-3360">
                    <Button variant="outline" size="sm" fullWidth data-id="element-3361">
                      {t('services.learnMore')}
                    </Button>
                  </Link>
                  <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="flex-1" data-id="element-3362">
                    <Button size="sm" fullWidth data-id="element-3363">
                      {t('nav.bookOnline')}
                    </Button>
                  </a>
                </div>
              </div>
            </Card>)}
        </div>
      </div>

      <div className="bg-ivory-200 py-16 lg:py-20" data-id="element-3364">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-3365">
          <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-3366">
            {t('servicesPage.readyToBook')}
          </h2>
          <p className="text-charcoal-light mb-8" data-id="element-3367">
            {t('servicesPage.readyToBookDesc')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-3368">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-3369">
              <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-3370">
                <Calendar className="w-5 h-5" data-id="element-3371" />
                {t('servicesPage.bookOnlineNow')}
              </Button>
            </a>
            <a href="https://wa.me/447345197820" target="_blank" rel="noopener noreferrer" data-id="element-3372">
              <Button variant="outline" size="lg" className="gap-2 w-full sm:w-auto border-beige/60 text-charcoal hover:bg-stone-100" data-id="element-3373">
                WhatsApp
              </Button>
            </a>
            <Link to={`/${lang}/contact`} data-id="element-3374">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-beige/60 text-charcoal hover:bg-stone-100" data-id="element-3375">
                {lang === 'en' ? 'Request a Call' : lang === 'ua' ? 'Замовити дзвінок' : lang === 'ru' ? 'Заказать звонок' : 'Solicitați un Apel'}
              </Button>
            </Link>
            <Link to={`/${lang}/prices`} data-id="element-3376">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-beige/60 text-charcoal hover:bg-stone-100" data-id="element-3377">
                {lang === 'en' ? 'View Prices' : lang === 'ua' ? 'Переглянути ціни' : lang === 'ru' ? 'Посмотреть цены' : 'Vedeți Prețurile'}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>;
}